import React from 'react';

function KnowledgeHubTitle({ text, isStickySize, isOtherPosts }) {
  return (
    <>
      <div className="title">{text || 'No Title'}</div>
      <style jsx>{`
        .title {
          font-family: 'big_noodle_titling';
          font-size: ${isOtherPosts ? '25px' : '31px'};
          font-weight: 400;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          color: #e4e4e4;
        }
        @media (max-width: 640px) {
          .title {
            font-size: ${isStickySize ? '31px' : '23px'};
            line-height: 29px;
          }
        }
      `}</style>
    </>
  );
}

export default KnowledgeHubTitle;
